import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { injectIntl } from 'react-intl'
import styles from './wizard-steps.styl'

@injectIntl
class WizardStep extends Component {
  static propTypes = {
    intl: PropTypes.object.isRequired,
    state: PropTypes.string.isRequired,
    activeState: PropTypes.string,
    title: PropTypes.string.isRequired,
    intlKey: PropTypes.string.isRequired,
    onStatusChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    hasSeparator: PropTypes.bool,
    isLast: PropTypes.bool
  }

  render() {
    const {
      state,
      activeState,
      title,
      onStatusChange,
      disabled,
      hasSeparator,
      intlKey,
      isLast,
      intl
    } = this.props
    const isActive = state === activeState
    const activeClass = isActive ? styles.active : ''
    const disabledClass = disabled && !isActive ? styles.disabled : ''
    const separatorClass = hasSeparator ? styles.separator : ''
    const lastClass = isLast ? styles.isLast : ''

    return (
      <li
        className={`${styles.item} ${disabledClass} ${activeClass} ${separatorClass} ${lastClass}`}
      >
        <button
          className={styles.button}
          type="button"
          disabled={disabled || isActive}
          onClick={() =>
            onStatusChange({
              label: intl.formatMessage({ id: intlKey, defaultMessage: title }),
              state
            })}
        >
          {intl.formatMessage({ id: intlKey, defaultMessage: title })}
        </button>
      </li>
    )
  }
}

export default WizardStep
